import { Box } from '@chakra-ui/react';
import { ReactComponent as OpacityIcon } from 'assets/icons/opacity.svg';
import { SliderPopover } from 'modules/common/components/ToolbarPopover';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

import { ImageWidgetData } from '../../ImageWidget.types';

const OpacityOption = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'imageToolbar' });
  const { opacity = 1, updateWidget } = useWidget<ImageWidgetData>();

  const label = t('toolbar.opacity');

  const onChangeOpacity = (newValue: number) => updateWidget({ opacity: newValue / 100 });

  return (
    <Box data-testid='opacity-option'>
      <SliderPopover
        value={Math.trunc(opacity * 100)}
        icon={<OpacityIcon />}
        label={label}
        onChange={onChangeOpacity}
        suffix='%'
        max={100}
        title={label}
      />
    </Box>
  );
};

export default OpacityOption;
